module.exports = __webpack_public_path__ + "img/ivkasirozas-thumb.8bd04b6b.jpg";